/* cf-preview-labels.js
 * Click Fencing - tidy the dimension labels drawn on the fence preview graphics.
 * Requested by Pete 2026-08-28: the labels collide and read as clutter.
 *   "50mm Post"            -> "50"
 *   "2400mm" + "Panel"     -> "2400" + ""      (the word Panel is dropped)
 *   "1700mm Panel" (glass) -> "1700"
 *   "Rake (ret. 1300mm)"   -> "1300"
 *   "27mm" (glass gap)     -> "27"
 * Kept as-is: the rotated vertical HEIGHT label ("1200mm"), "Gate", "Cut",
 * and every word outside the preview graphic. HTML_SCOPE deliberately stops at
 * #section-preview and NOT at .live-preview-wrapper: glass keeps its
 * "Calculation Results" panel (#calculation-results) inside that wrapper, and the
 * wider scope stripped "Panel Length: 1500mm" to "1500". Caught on the preview
 * theme 2026-08-28 before publish.
 * Display only - touches no price, product, quantity or cart line.
 */
(function () {
  if (window.__cfPreviewLabelsPatched) return;
  window.__cfPreviewLabelsPatched = true;

  var HTML_SCOPE = '#section-preview, .visual-preview, .panels-container, .panel-preview';

  function rewrite(t) {
    var m;
    if (/^Panel$/.test(t)) return '';
    if (/^Hinge Panel$/.test(t)) return 'Hinge';
    if ((m = /^Rake \(ret\.\s*(\d+)\s*mm\)$/.exec(t))) return m[1];
    if ((m = /^(\d+)\s*mm\s+(?:Post|Panel)$/.exec(t))) return m[1];
    if ((m = /^(\d+)\s*mm$/.exec(t))) return m[1];
    return null;
  }

  function isPreviewSvg(svg) {
    try {
      if (svg.closest('[id*="preview"], [class*="preview"], [class*="visual"]')) return true;
      var ts = svg.querySelectorAll('text');
      for (var i = 0; i < ts.length; i++) {
        if (/^(Panel|Gate|Cut|\d+\s*mm\s+(Post|Panel)|Rake \(ret)/.test(ts[i].textContent.trim())) return true;
      }
    } catch (e) {}
    return false;
  }

  function doSvg() {
    var svgs = document.querySelectorAll('svg');
    for (var i = 0; i < svgs.length; i++) {
      var svg = svgs[i];
      if (!isPreviewSvg(svg)) continue;
      var texts = svg.querySelectorAll('text');
      for (var j = 0; j < texts.length; j++) {
        var el = texts[j];
        var tr = el.getAttribute('transform') || '';
        if (/rotate/i.test(tr)) continue;
        if (el.children.length) continue;
        var cur = el.textContent, out = rewrite(cur.trim());
        if (out !== null && out !== cur) el.textContent = out;
      }
    }
  }

  function doHtml() {
    var roots = document.querySelectorAll(HTML_SCOPE);
    for (var i = 0; i < roots.length; i++) {
      var leaves = roots[i].querySelectorAll('div, span');
      for (var j = 0; j < leaves.length; j++) {
        var el = leaves[j];
        if (el.children.length) continue;
        var cur = el.textContent, out = rewrite(cur.trim());
        if (out !== null && out !== cur) el.textContent = out;
      }
    }
  }

  var queued = false;
  function apply() {
    queued = false;
    try { doSvg(); } catch (e) {}
    try { doHtml(); } catch (e) {}
  }
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(apply, 0);
  }

  try {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true, subtree: true, characterData: true
    });
  } catch (e) {}

  // Permanent safety net, deliberately not time-limited. Verified 2026-08-28 on blade:
  // flipping the gate hinge side redraws the preview into a BRAND NEW <svg>, and the
  // MutationObserver did not fire a pass that caught it - the drawing showed hinges on
  // the left while the annotation still read the old right-hand geometry. A single DOM
  // poke fixed it instantly, so the work is right and only the trigger was missed. The
  // pass is a few querySelectorAll calls over a small subtree, so running it for the
  // life of the page costs nothing and a customer can sit on this page for minutes.
  setInterval(apply, 1200);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  apply();
  console.log('[cf-preview-labels] installed');
})();
